const ScheduleTypeHelperMixin = {
  methods: {
    scheduleTypeIcon (scheduleType) {
      return scheduleType === 'recurring' ? 'mdi-alarm-multiple' : 'mdi-alarm'
    },
    scheduleTypeColor (scheduleType) {
      return scheduleType === 'recurring' ? 'teal' : 'cyan'
    }
  }
}

export default ScheduleTypeHelperMixin
